"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClubInvoiceComponent = void 0;
var ClubInvoice_1 = require("./ClubInvoice");
Object.defineProperty(exports, "ClubInvoiceComponent", { enumerable: true, get: function () { return ClubInvoice_1.ClubInvoiceComponent; } });
